import React, { Component } from 'react';
import logo from "../assets/primal/branding/YellowLogo.png";
import SetImage from "../assets/primal/front/APLogo.png"
import Set2Image from "../assets/primal/front/BBLogo.png"
import Set3Image from "../assets/primal/front/SSlogo.png"
import Set4Image from "../assets/primal/front/NGlogo.png"
import "./Banner.css";

const API_URL = 'https://api.primaltcg.com';

export default class Banner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      announcement: null,
      loading: true
    };
  }

  componentDidMount() {
    if (this.props.homepage) {
      this.fetchAnnouncement();
    }
  }

  async fetchAnnouncement() {
    try {
      const response = await fetch(`${API_URL}/api/v1.1/announcements?platform=website`);
      const data = await response.json();
      if (data && data.title) {
        this.setState({ announcement: data, loading: false });
      } else {
        this.setState({ loading: false });
      }
    } catch (e) {
      console.error('Failed to fetch announcement:', e);
      this.setState({ loading: false });
    }
  }

  scrollToSection = (e) => {
    e.preventDefault();
    const element = document.querySelector(this.props.cta.link);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  render() {
    if (this.props.homepage) {
    return (
      <div className="row">
          <div className="col-md-12 col-xs-12">
            <div className="page-header" 
              style={{ backgroundImage: `url(${window.innerWidth > 867 ? this.props.banner : this.props.mobileBanner })`, height: "100ch"}}>
               <div className="filter" /> 
              <div className="content-center">
                <div className="container">
                  <div className="motto">
                    {/* <img id="logoBanner" alt="Primal Trading Card Game Logo" src={logo} />
                    <h3 className="subtitle">First Ed Booster Set</h3> 
                    <img id="logoBanner" alt="Awakened Primordials Logo" src={SetImage} />
                    <h4 className="description">Release Date: April 20, 2024</h4>
                    <br />
                    <a href="/salesheet" style={{ backgroundColor: "black", color: "white" }} className="dlbtn btn btn-neutral btn-round">View Sales Sheet</a>
                    <a href="/search/results/custom=all" style={{ backgroundColor: "white", color: "black" }} className="dlbtn btn btn-neutral btn-round">View All Cards</a>

                    <div onClick={() => {window.open("https://shop.primaltcg.com")}}  style={{ backgroundColor: "green", color: "white", cursor:"pointer" }} className="dlbtn btn btn-neutral btn-round">Buy Primal TCG</div> */}
                    
                    {this.state.announcement && this.state.announcement.imageOption === 'custom' && this.state.announcement.image && (
                      <img id="logoBanner" alt="Announcement" src={this.state.announcement.image} />
                    )}
                    {this.state.announcement && this.state.announcement.imageOption === 'fallback' && (
                      <img id="logoBanner" alt="New Genesis Logo" src={Set4Image} />
                    )}
                    {(!this.state.announcement || !this.state.announcement.imageOption) && (
                      <img id="logoBanner" alt="New Genesis Logo" src={Set4Image} />
                    )}
                    <h3 className="subtitle">
                      {this.state.announcement && this.state.announcement.title
                        ? this.state.announcement.title
                        : 'Set 4 Pre-Orders Available - Next Generation of Primal'}
                    </h3>
                    {this.state.announcement && this.state.announcement.message && (
                      <p className="description" style={{ color: 'white', maxWidth: '600px', margin: '0 auto' }}>
                        {this.state.announcement.message}
                      </p>
                    )}
                    <br />
                    <br />
                    {this.state.announcement && this.state.announcement.buttons && this.state.announcement.buttons.length > 0 && (
                      this.state.announcement.buttons.map((button, index) => (
                        <a
                          key={index}
                          href={button.link}
                          style={{ backgroundColor: button.backgroundColor, color: button.textColor }}
                          className="dlbtn btn btn-neutral btn-round"
                        >
                          {button.title}
                        </a>
                      ))
                    )}
                    {/* <a href="/search/results/custom=cayne-pirates" style={{ backgroundColor: "#27acc1", color: "white" }} className="dlbtn btn btn-neutral btn-round">Cayne Pirates</a>
                    <a href="/search/results/custom=draginked" style={{ backgroundColor: "purple", color: "white" }} className="dlbtn btn btn-neutral btn-round">Draginked</a>
                    <a href="/search/results/custom=micromons" style={{ backgroundColor: "#ab9000", color: "white" }} className="dlbtn btn btn-neutral btn-round">Micromons</a>
                    <a href="/search/results/custom=symbiotes" style={{ backgroundColor: "#cd2600", color: "white" }} className="dlbtn btn btn-neutral btn-round">Symbiote Dragons</a>
                    <a href="/search/results/custom=pleaguis" style={{ backgroundColor: "black", color: "white" }} className="dlbtn btn btn-neutral btn-round">Pleaguis</a> */}
                    {/* <a href="https://apps.apple.com/us/app/card-collector-naruto-edition/id1460633152" className="dlbtn btn btn-neutral btn-round"><i className="fa fa-apple" aria-hidden="true"/>iPhone</a>
                    <a href="/android" className="dlbtn btn btn-success btn-round"><i className="fa fa-android" aria-hidden="true"/>Download Android APK</a> */}
                  </div>
                </div>
              </div> 
            </div>
          </div>
        </div>
    );
    }

    return (
      <div className="row">
          <div className="col-md-12 col-xs-12">
            <div className="page-header" 
              style={{ backgroundImage: `url(${window.innerWidth > 867 ? this.props.banner : this.props.mobileBanner })`, height: "100ch"}}>
               <div className="filter" /> 
              <div className="content-center">
                <div className="container">
                  <div className="motto">
                    <h3 className="subtitle">{this.props.message}</h3> 
                    <br />
                    <br />
                    <a 
                      href={this.props.cta.link} 
                      onClick={this.scrollToSection}
                      style={this.props.cta.style} 
                      className="dlbtn btn btn-neutral btn-round"
                    >
                      {this.props.cta.message}
                    </a>
                    {/* <a href="/search/results/custom=cayne-pirates" style={{ backgroundColor: "#27acc1", color: "white" }} className="dlbtn btn btn-neutral btn-round">Cayne Pirates</a>
                    <a href="/search/results/custom=draginked" style={{ backgroundColor: "purple", color: "white" }} className="dlbtn btn btn-neutral btn-round">Draginked</a>
                    <a href="/search/results/custom=micromons" style={{ backgroundColor: "#ab9000", color: "white" }} className="dlbtn btn btn-neutral btn-round">Micromons</a>
                    <a href="/search/results/custom=symbiotes" style={{ backgroundColor: "#cd2600", color: "white" }} className="dlbtn btn btn-neutral btn-round">Symbiote Dragons</a>
                    <a href="/search/results/custom=pleaguis" style={{ backgroundColor: "black", color: "white" }} className="dlbtn btn btn-neutral btn-round">Pleaguis</a> */}
                    {/* <a href="https://apps.apple.com/us/app/card-collector-naruto-edition/id1460633152" className="dlbtn btn btn-neutral btn-round"><i className="fa fa-apple" aria-hidden="true"/>iPhone</a>
                    <a href="/android" className="dlbtn btn btn-success btn-round"><i className="fa fa-android" aria-hidden="true"/>Download Android APK</a> */}
                  </div>
                </div>
              </div> 
            </div>
          </div>
        </div>
    );
  }
}